import { Injectable } from '@angular/core';
import { BaseHttpService, Query, UriBuilderParams } from './base/base-http.service';
import { CodeValue } from '../../shared/models/code-value';
import { HttpServiceBundle } from './base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { BaseList } from '../../shared/models/list';
import { DrQueryParams } from '@app/core/services/base/base-service-with-bundle.service';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';

export class SettingsUriBuilderParams extends UriBuilderParams<CodeValue> {

  constructor(code?: CodeValue | string) {
    super(code);
  }

  public buildUri(): string {
    return this.simpleUriBuild(`${BackendUriUnits.CLIENTS}/${BackendUriUnits.SETTINGS}`);
  }
}

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends BaseHttpService<CodeValue, SettingsUriBuilderParams>
                             implements Query<CodeValue, SettingsUriBuilderParams> {

  constructor(httpServiceBundle: HttpServiceBundle) {
    super(CodeValue, httpServiceBundle, true);
  }

  public query(uriParams: SettingsUriBuilderParams, params?: DrQueryParams, propOverride?: string): Observable<BaseList<CodeValue>> {
    return this.queryBase(uriParams, params, propOverride);
  }
}
